export default __webpack_public_path__ + "static/FHAlphaTest-LightItalic-21feabb7dd052f56cb920b93e89e8559.otf";